import React, {Component} from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import { includes } from 'lodash';

import FileInputButton from '../../shared/components/forms/FileInputButton';

class TradeDocumentNotification extends Component {
  static defaultProps = {};

  replaceFiles = e => {
    return this.props.onFileChange(e, true);
  };

  notificationClass = action => {
    let containerClass = '';
    const successActions = [
      'view_loan_offer',
      'submit_another_trade_doc_approved'
    ];

    const failedActions = [
      'submit_another_trade_doc_rejected',
      'loan_offer_expired',
      'add_contact',
      'add_supporting_document',
      'append_image',
      'change_image',
      'no_buyer_stamp_on_document',
      'additional_supporting_documents_needed',
      'blurry_image',
      'cropped_image',
      'incomplete_pages',
      'grouped_documents',
      'not_endorsed_by_buyer',
      'terms_not_yet_finalized',
      'not_yet_received_by_accounting_department',
      'cannot_contact_buyer',
      'other'
    ];

    if(includes(successActions, action)) {
      containerClass = 'ds-card -success';
    } else if(includes(failedActions, action)) {
      containerClass = 'ds-card -danger';
    }

    return containerClass;
  };

  renderCallToAction = action => {
    switch (action) {
      case 'add_contact':
      case 'cannot_contact_buyer':
        return (
          <button
            className="ds-btn -danger --small"
            onClick={this.props.onClickAddContactButton}
            data-testid="add-contact-person-button"
            name={action}>
            Add Another Contact Person
          </button>
        );
      case 'not_endorsed_by_buyer':
        return (
          <button
            className="ds-btn -danger --small"
            onClick={this.props.onClickAddContactButton}
            data-testid="add-contact-person-button"
            name={action}>
            Add the Contact Person
          </button>
        );
      case 'add_supporting_document':
        return (
          <button
            className="ds-btn -danger --small"
            onClick={this.props.redirectToSupportingDocuments}
            name={action}>
            Submit a Supporting Document
          </button>
        );
      case 'additional_supporting_documents_needed':
        return (
          <button
            className="ds-btn -danger --small"
            onClick={() => {
              this.props.onClickResubmitDocument();
              this.props.redirectToSupportingDocuments();
            }}
            data-testid="resubmit-document-input"
            name={action}>
            Submit a Supporting Document
          </button>
        );
      case 'append_image':
        return (
          <FileInputButton
            multiple={true}
            className="file-picker -danger _marginLeft--small --small"
            name={`${this.props.tradeDocumentType}_attachments`}
            accept="image/*,application/pdf"
            buttonText="Add Pages"
            onChange={this.props.onFileChange}
            ref="upload_attachments"
          />
        );
      case 'change_image':
      case 'no_buyer_stamp_on_document':
      case 'blurry_image':
      case 'cropped_image':
      case 'grouped_documents':
      case 'not_yet_received_by_accounting_department':
      case 'terms_not_yet_finalized':
      case 'other':
        return (
          <FileInputButton
            multiple={true}
            className="file-picker -danger _marginLeft--small --small"
            name={action}
            accept="image/*,application/pdf"
            buttonText="Resubmit Document"
            onChange={this.replaceFiles}
            ref="replace_attachments"
            dataTestId="resubmit-document-input"
            onClick={this.props.onClickResubmitDocument}
          />
        );
      case 'view_loan_offer':
        return <button className="ds-btn -success --small" onClick={() => {this.props.dispatch(push('/'))}}>View Loan Offer</button>;
      case 'submit_another_trade_doc_approved':
        var path_name = '';

        if (this.props.tradeDocument.loan_plan.is_setup_complete) {
          path_name = `/loan_plan_overview/${this.props.tradeDocument.loan_plan.id}`;
        } else if (
          !this.props.tradeDocument.loan_plan.has_accepted_loan_responsibility
        ) {
          path_name = `/pending_loan_offers/${this.props.tradeDocument.loan_offer.id}/loan_plans/${this.props.tradeDocument.loan_plan.id}/loan_terms`;
        } else if (!this.props.tradeDocument.loan_plan.signed_date) {
          path_name = `/pending_loan_offers/${this.props.tradeDocument.loan_offer.id}/loan_plans/${this.props.tradeDocument.loan_plan.id}/sign_loan_agreement`;
        } else if (
          !this.props.tradeDocument.loan_plan.has_provided_cheque_identifiers
        ) {
          path_name = `/pending_loan_offers/${this.props.tradeDocument.loan_offer.id}/loan_plans/${this.props.tradeDocument.loan_plan.id}/upload_cheques`;
        } else {
          path_name = `/pending_loan_offers/${this.props.tradeDocument.loan_offer.id}/loan_plans/${this.props.tradeDocument.loan_plan.id}/cheques_collection`;
        }

        return (
          <button
            className="ds-btn -secondary --small"
            onClick={() => {
              this.props.dispatch(push(path_name));
            }}>
            View Loan Plan
          </button>
        );
      case 'submit_another_trade_doc_rejected':
        return (
          <button
            className="ds-btn -secondary --small"
            onClick={() => {
              this.props.dispatch(
                push(`/${this.props.tradeDocumentType}s/new`),
              );
            }}>
            Submit New
          </button>
        );
      case 'incomplete_pages':
        return (
          <FileInputButton
            multiple={true}
            name={action}
            accept="image/*,application/pdf"
            className="file-picker -danger _marginLeft--small --small"
            buttonText="Add more pages"
            onChange={this.props.onFileChange}
            ref="upload_attachments"
            dataTestId="resubmit-document-input"
            onClick={this.props.onClickResubmitDocument}
          />
        );
      default:
        return null;
    }
  };

  render() {
    if (
      this.props.tradeDocument &&
      this.props.tradeDocument.is_loan_offer_expired
    ) {
      return (
        <div className={this.notificationClass("loan_offer_expired")}>
          <section className="cardSection _withColumns _justifyContent-space-between">
            <div className="text">
              <p className="subhead _marginBotom--normal"> {"Loan Offer Expired"} </p>
              <p className="copy">
                {
                  'Unfortunately the loan offer for this application has now expired. Feel free to contact your account manager.'
                }
              </p>
            </div>
            {this.renderCallToAction('loan_offer_expired')}
          </section>
        </div>
      );
    }

    if (
      !this.props.notification ||
      !this.props.notification.show ||
      !this.props.show
    )
      return <div />;
    let {header, message, fca_action} = this.props.notification;

    return (
      <div className={this.notificationClass(fca_action)}>
          <section className="cardSection _withColumns _justifyContent-space-between">
          <div className="text _marginBottom--small-mobileOnly">
            <p className="subhead _marginBotom--normal"> {header} </p>
            <p className="copy" dangerouslySetInnerHTML={{__html: message}} />
          </div>
          {this.renderCallToAction(fca_action)}
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(TradeDocumentNotification);



// WEBPACK FOOTER //
// ./src/features/trade_documents/containers/TradeDocumentNotification.js